import { render, staticRenderFns } from "./UserCertificate.vue?vue&type=template&id=9e1a2e88&"
import script from "./UserCertificate.vue?vue&type=script&lang=js&"
export * from "./UserCertificate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports